module.exports = __webpack_public_path__ + "static/parnter 04@2x-5e3ae2e3064410904541357ed7b5acea.png";